import { Component } from '@angular/core';
import { Platform } from '@ionic/angular';
import { ConfigService } from 'src/app/services/config/config.service';
import { UniqueIDService } from 'src/app/services/unique-id/unique-id.service';
import { Navigator } from "src/app/services/routing/navigator";

@Component({
    selector: 'app-restricted',
    templateUrl: './app-restricted.component.html',
    styleUrls: ['./app-restricted.component.scss'],
})
export class AppRestrictedComponent {

    public tapCount = 0;
    public tapTimeoutID: any = 0;
    public deviceId: any;
    public showDeviceId = false
    private unregisterBackButtonAction: any;

    constructor(
        protected platform: Platform,
        public config: ConfigService,
        public navigator: Navigator,
        private uniqueIDProvider: UniqueIDService,
    ) {
        this.uniqueIDProvider.getSelectorID().then(
            response => {
                // console.log("uniqueIDProvider.getSelectorID()", response)
                this.deviceId = response
            },
            reject => {
                // console.log("error uniqueIDProvider.getSelectorID()", reject)
                this.deviceId = "Not available!"
            }
        );
        this.initializeBackButtonCustomHandler();
    }

  

    ionViewWillLeave() {
        this.unregisterBackButtonAction && this.unregisterBackButtonAction();
    }

    initializeBackButtonCustomHandler() {
        this.platform.backButton.subscribeWithPriority(100, (event) => {
            console.log('Prevent Back Button Page Change... You Stuck!');
            this.navigator.navigateTo("AppRestrictedComponent", {}, {});
        });
    }
    
    onLogoTap() {
        // if (this.platform.is('capacitor')) {
            this.tapCount += 1;

            clearTimeout(this.tapTimeoutID);

            if (this.tapCount >= 10) {
                this.showDeviceId = true
            }
            else {
                this.tapTimeoutID = setTimeout(() => {
                    this.tapCount = 0;
                }, 5000)
            }
        // }
    }
}
